import styled from 'styled-components';

import theme from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: auto;
  background-color: ${theme.background};
  flex-direction: column;
  padding: 40px 20px;
`;

export const SuccessFeedback = styled.div`
  display: flex;
  flex: 1;
  z-index: 2;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: ${theme.background};
  visibility: ${({ submitted }) => (submitted ? 'visible' : 'hidden')};
  position: absolute;
  top: 0;
  margin: auto;
`;

export const Text = styled.span`
  color: ${theme.accent};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  font-size: ${({ smallText }) => (smallText ? '16px' : '30px')};
  text-align: center;
  margin: 0px;
  margin: 30px 0;
`;

export const TextHighlight = styled.mark`
  color: ${theme.primary};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  font-size: ${({ smallText }) => (smallText ? '16px' : '30px')};
  text-align: center;
  margin: 0px;
  background-color: transparent;
  margin: 30px 0;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex: 10;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SubTextWrapper = styled.div`
  display: flex;
  flex: 2;
  flex-direction: row;
`;

// export const Text = styled.p`
//   color: ${theme.accent};
//   font-size: 48px;
//   font-weight: bold;
// `;

// export const Highlight = styled.mark`
//   color: ${theme.primary};
//   font-size: 48px;
//   font-weight: bold;
// `;
